import { CollapsibleTrigger } from "@components/ui/collapsible";
import { Trans } from "@lingui/react/macro";
import { ChevronsUpDownIcon } from "lucide-react";
import MentionTimingDisplay from "./MentionTimingDisplay";
import { MentionV4 } from "@/types/MentionCard";

export default function MentionCollapsibleTrigger({
  indicesMetadata,
  isDescriptionMention,
  mentionsCount,
  displayIndex,
}: {
  indicesMetadata: MentionV4["indices_metadata"];
  isDescriptionMention: boolean;
  mentionsCount: number;
  displayIndex: number;
}) {
  return (
    <CollapsibleTrigger className="text-left p-3 bg-muted-secondary rounded-md w-full flex items-center justify-between group-data-[state=open]/collapsible:rounded-b-none group-data-[state=open]/collapsible:pb-2 peer">
      <div className="flex items-center gap-2 flex-1">
        {typeof indicesMetadata?.start_time === "number" ? (
          <MentionTimingDisplay indicesMetadata={indicesMetadata} />
        ) : null}

        <p className="text-sm font-medium">
          {isDescriptionMention ? (
            <Trans>Omnämnande i avsnittets beskrivning</Trans>
          ) : (
            <Trans>
              Omnämnande {displayIndex} av {mentionsCount}
            </Trans>
          )}
        </p>
      </div>
      <ChevronsUpDownIcon className="size-3.5 text-muted-foreground" />
    </CollapsibleTrigger>
  );
}
